import $ from 'jquery';
import autosize from 'autosize';
import datepicker from 'js-datepicker';

const calendar = {
  de: {
    months: [
      'Jan',
      'Feb',
      'Mär',
      'Apr',
      'Mai',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Okt',
      'Nov',
      'Dez',
    ],
    days: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  },
};

// Links
// ----------------------------------------------------------------

$('a[rel~=external]').click((event) => {
  event.stopPropagation();
  event.preventDefault();

  window.open(this.href);
});

// Tooltips
// ----------------------------------------------------------------

if ($('#tooltip').length === 0) {
  $('<div id="tooltip"></div>').prependTo('body').hide();
}

// TODO: modularize
(function () {
  var oldStatus = window.status;
  var tooltipOffset = [-24, 32];

  $('body')
    .on('mouseenter.tooltip', 'a[title]', function (event) {
      var $this = $(this),
        text = $this.attr('title');

      if (!text) {
        text = $this.data('title');
        if (!text) return;
      } else {
        $this.data('title', text).prop('title', '');
      }

      oldStatus = window.status;
      window.status = text;

      var tooltip = $('#tooltip').text(text).show(),
        top = parseInt(event.pageY, 10) + tooltipOffset[0] + 32,
        left = parseInt(event.pageX, 10) + tooltipOffset[1];
      tooltip.hide();
      left = Math.min(left, $(document.body).width() - tooltip.width() - 32);

      // TODO: avoid scollbars
      tooltip
        .stop()
        .fadeTo('fast', 1.0)
        .css({
          top: top + 'px',
          left: left + 'px',
        });
    })
    .on('mouseleave.tooltip', 'a[title]', function (event) {
      window.status = oldStatus;
      $('#tooltip').stop().fadeOut('fast');
    });

  $(document.body).on('mousemove', 'a[title]', function (event) {
    var tooltip = $('#tooltip'),
      top = parseInt(event.pageY, 10) + tooltipOffset[0] + 32,
      left = parseInt(event.pageX, 10) + tooltipOffset[1];
    left = Math.min(left, $(document.body).width() - tooltip.width() - 32);

    tooltip.css({
      top: top + 'px',
      left: left + 'px',
    });
  });
})();

// Autosize textareas
// ----------------------------------------------------------------

$(() => {
  autosize(document.querySelectorAll('textarea.autosize'));
});

// Dialogs
// ----------------------------------------------------------------

// fire notifications
$.each(window['notifications'] || [], function () {
  $.notify(this.title, this.message);
});

// Datefields
// ----------------------------------------------------------------

$(() => {
  const datepickerOptions = {
    startDay: 1,
    customMonths: calendar.de.months,
    customDays: calendar.de.days,
    disableMobile: true,
    formatter: (input, date, instance) => {
      const d = `${date.getDate()}`.padStart(2, '0');
      const m = `${1 + date.getMonth()}`.padStart(2, '0');
      const y = `${date.getFullYear()}`;
      input.value = `${d}.${m}.${y}`;
    },
  };

  const dateFields = document.querySelectorAll('.xi-date-field');
  if (dateFields != null) {
    for (const dateFields of dateFields) {
      datepicker(dateFields, datepickerOptions);
    }
  }
});

// Geocoding
// ----------------------------------------------------------------

// function geocodeGoogle(address, callback) {
//   const url = 'http://maps.googleapis.com/maps/api/geocode/json';
//
//   $.get(url, {
//     address: address,
//     sensor: 'false',
//     bounds: '49.941,7.646|50.150,8.486'
//   }).done(function(data) {
//     if (data.results && data.results.length) {
//       const loc = data.results[0].geometry.location;
//       callback(loc.lat, loc.lng);
//     } else {
//       if (window.console && window.console.log) {
//         console.log('failed geocoding ', address);
//       }
//     }
//   });
// };

// https://wiki.openstreetmap.org/wiki/Nominatim
function geocodeNominatim(address, callback) {
  const url = 'https://nominatim.openstreetmap.org/search';
  $.get(url, {
    q: address,
    format: 'json',
    bounded: 1,
    viewbox: '7.646,49.941,8.486,50.150',
  }).done((data) => {
    if (Array.isArray(data)) {
      for (const result of data) {
        if (result.lat && result.lon) {
          callback(result.lat, result.lon);
          return;
        }
      }
      if (console != null && console.error != null) {
        console.error('failed geocoding', address);
      }
    }
  });
}

$.geocode = geocodeNominatim;

$(function () {
  $('.geocode-trigger').on('click', function () {
    const a = $(this);
    const fieldlist = a.data('geocode-fields') || 'address, zip, city';
    const fields = $.map(fieldlist.split(','), $.trim);

    const values = $('input')
      .filter(function () {
        return fields.indexOf(this.name) > -1;
      })
      .map(function () {
        const input = $(this);
        const val = input.val();
        return input.attr('name') == 'zip' ? val : val + ',';
      });

    const address = Array.prototype.join
      .call(values, ' ')
      .replace(/[\s,]*$/, '');

    $.geocode(address, function (lat, lng) {
      $('input[name=lat]').val(lat);
      $('input[name=lng]').val(lng);
    });

    return false;
  });
});

// Summary
// ----------------------------------------------------------------

$(() => {
  const panel = document.querySelector('.news-panel');
  if (panel != null) {
    const editButton = panel.querySelector('.admin-news-panel-edit-news');
    const editForm = panel.querySelector('form');
    const preview = panel.querySelector('.news-preview');

    if (editButton != null && editForm != null) {
      editButton.addEventListener('click', () => {
        editForm.classList.remove('hidden');
        editButton.classList.add('hidden');
        preview.classList.add('hidden');
      });
    }
  }
});
